import axios from 'axios';
import './GlobalVariables';

const API_URL = `${global.SET_API_URL}bakeryPos`;

export const createForwardInvoice = async (payload) => (
  (await axios.post(`${API_URL}/forward-invoices`, payload)).data.data
);

export const updateForwardInvoice = async (lookup, payload) => (
  (await axios.put(`${API_URL}/forward-invoices/${encodeURIComponent(lookup)}`, payload)).data.data
);

export const getForwardInvoice = async (lookup) => (
  (await axios.get(`${API_URL}/forward-invoices/${encodeURIComponent(lookup)}`)).data.data
);

export const getUnpaidForwardInvoices = async (branchID, userID, salesmanUserID = null) => (
  (await axios.get(`${API_URL}/forward-invoices`, { params: { branchID, userID, salesmanUserID } })).data.data
);

export const payForwardInvoice = async (lookup, payload) => (
  (await axios.post(`${API_URL}/forward-invoices/${encodeURIComponent(lookup)}/pay`, payload)).data
);

export const cancelForwardInvoice = async (lookup, reason, salesmanUserID = null) => (
  (await axios.post(`${API_URL}/forward-invoices/${encodeURIComponent(lookup)}/cancel`, { reason, salesmanUserID })).data
);

export const printForwardInvoice = async (lookup) => (
  (await axios.post(`${API_URL}/forward-invoices/${encodeURIComponent(lookup)}/print`)).data
);

export const createBakeryDirectSale = async (payload) => (
  (await axios.post(`${API_URL}/direct-sales`, payload)).data
);

export const getBakerySaleForReturn = async (lookup) => (
  (await axios.get(`${API_URL}/sales-returns/${encodeURIComponent(lookup)}`)).data.data
);

export const createBakerySaleReturn = async (lookup, payload) => (
  (await axios.post(`${API_URL}/sales-returns/${encodeURIComponent(lookup)}`, payload)).data
);
